<template>
  <suc-select-component
    :title="$t('pages.planing-team.workshift.title')"
    :options="options"
    label="description"
    :form="form"
    :name="name"
    :reduce="(x) => x.code"
  >
    <template #no-options>{{ $t("components.fields.no_options") }}</template>
  </suc-select-component>
</template>

<script>
import { SucSelectComponent, SUC_SELECT_CHANGED_EVENT, Form } from "@/components/form";

import api from "@/api/workshift";
import { WorkShift } from "@/pages/responsible/planing/workshift/data";

export default {
  components: {
    SucSelectComponent,
  },
  props: {
    initValue: {
      type: String,
    },
    name: {
      type: String,
      required: true,
    },
    form: {
      type: Form,
      required: true,
    },
  },
  data() {
    return {
      options: [],
      value: null,
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      const { data } = await api.getWorkShifts();
      this.options = data.map((x) => new WorkShift().parse(x));
      if (this.$isset(this.initValue)) {
        this.onChangeField(this.options.find((x) => x.employeeCode == this.initValue));
      }
    },
    onChangeField(option) {
      this.form[this.name] = option;
      this.$emit(SUC_SELECT_CHANGED_EVENT, this.$deepCopy(this.value));
    },
  },
};
</script>

<style scoped></style>
